import type { UseRefinementListProps } from 'react-instantsearch';
import { useDynamicWidgets, useRefinementList } from 'react-instantsearch';

const Refinement = (props: UseRefinementListProps) => {
  useRefinementList(props);
  return null;
};

// Needed to percist refinements when using useDynamicWidgets
const VirtualRefinements = () => {
  const { attributesToRender } = useDynamicWidgets({
    facets: ['*'],
  });

  return (
    <>
      {attributesToRender.map(attr => (
        <Refinement attribute={attr} key={attr} />
      ))}
    </>
  );
};

export default VirtualRefinements;
